module.exports = __webpack_public_path__ + "static/media/sad-emoji.63c08fef.png";